export enum TheaterStatus {
  ClosedPermanently = 'Closed Permanently',
  ClosedTemporarily = 'Closed Temporarily',
  Open = 'Open',
  OpeningSoon = 'Opening Soon',
}
